import { Column } from '@material-table/core';
import { EventRoleWithMemberships } from '@modules/supabase/events';
import { Tooltip } from '@mui/material';
import { STATUS_LOOKUP } from '@utils/team-table-utils';
import { MembershipStatusChip } from './MembershipStatusChip';

export const RegistrationStatusColumn: Column<EventRoleWithMemberships> = {
    lookup: STATUS_LOOKUP,
    title: 'Status',
    field: 'memberships',
    render: ({ memberships }) => (
        <>
            {memberships.map(({ status, role, count, names }, i) => (
                <Tooltip
                    key={`${status}-${role}-${count}-${names.join('-')}`}
                    placement="left"
                    title={<div style={{ whiteSpace: 'pre-line' }}>{names.join(', \n\r')}</div>}
                    style={{ marginTop: i ? '.25rem' : 0 }}
                >
                    <div>
                        <MembershipStatusChip status={status} role={role} count={count} />
                    </div>
                </Tooltip>
            ))}
        </>
    ),
};
